"use client";

var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import MuscleSelectInput from "../select-input";
import { getCountriesList } from "@lib/util/countries-ops";
const MuscleCountryInput = _ref => {
  let {
    label = "",
    value = "",
    onChange = () => {},
    disabled = false,
    required = false,
    labelClassName = "",
    maxDropdownHeight = 450,
    reserveErrorSpace = false,
    dataTestId,
    invalidValueMessage,
    valueIsInvalid
  } = _ref;
  const {
    0: countriesOptions,
    1: setCountriesOptions
  } = useState([]);
  const {
    0: selectedCountryCode,
    1: setSelectedCountryCode
  } = useState(value);
  useEffect(() => {
    getAndSetCountriesOptions();
  }, []);
  useEffect(() => {
    if (value) {
      setSelectedCountryCode(value);
    }
  }, [value]);
  const getAndSetCountriesOptions = async () => {
    const countryCodes = getCountriesList();
    const countriesOptions = parseCountriesToOptions(countryCodes);
    setCountriesOptions(countriesOptions);
  };
  const parseCountriesToOptions = countries => {
    return Object.keys(countries).map(countryCode => ({
      key: countryCode,
      value: countries[countryCode]
    })).sort((a, b) => {
      const valueA = a.value.toLowerCase();
      const valueB = b.value.toLowerCase();
      if (valueA < valueB) {
        return -1;
      }
      if (valueA > valueB) {
        return 1;
      }
      return 0;
    });
  };
  const handleChange = selectedOption => {
    setSelectedCountryCode(selectedOption.key);
    onChange(selectedOption.key);
  };
  return __jsx(MuscleSelectInput, {
    required: required,
    label: label,
    options: countriesOptions,
    disabled: disabled,
    onSelectOption: handleChange,
    value: countriesOptions.find(country => country.key === selectedCountryCode),
    focusOptionsByTyping: true,
    inlineModeConfiguration: {
      labelClassname: labelClassName,
      labelTitleClassName: labelClassName
    },
    maxDropdownHeight: maxDropdownHeight,
    reserveErrorSpace: reserveErrorSpace,
    dataTestId: dataTestId,
    invalidValueMessage: invalidValueMessage,
    valueIsInvalid: valueIsInvalid || (selectedCountryCode === null || selectedCountryCode === void 0 ? void 0 : selectedCountryCode.length) !== 2
  });
};
export default MuscleCountryInput;